<div class="modal-container-content">
  <span>
    Je staat op het punt om uit te loggen. Weet je zeker dat je hier mee door wil gaan?
  </span>
</div>

<div class="modal-container-footer">
  <app-button (click)="submit()" (keyup.enter)="submit()" type="primary">Uitloggen</app-button>
</div>
